<script setup lang="ts">
const props = defineProps<{
   product_id: number;
   optionsPrices: {
      title: string;
      price: number;
      id: number;
      max: number;
      min: number;
   }[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void;
}>();

const emitTotalParticipants = () => {
  const total = optionsWithCount.reduce((sum, item) => sum + item.count, 0);
  emit('update:modelValue', total);
};

const cartStore = useCartStore();

const optionsWithCount = cartStore.getOptionsWithCount(props.product_id);

const increment = (product_id: number, index: number) => {
   cartStore.increment(product_id, index);
    emitTotalParticipants();
};

const decrement = (product_id: number, index: number) => {
   cartStore.decrement(product_id, index);
   emitTotalParticipants();
};
</script>

<template>
   <div
      class="flex w-full mb-4 justified-between"
      v-for="(item, index) in optionsWithCount"
   >
      <div class="w-full">
         <p class="text-sm font-medium text-gray-600">
            {{ item.title }}(Per Person)
         </p>
         <bdi class="text-secondary">
            <span class="currency-symbol">US$</span>
            <span>{{ item.price }}</span>
         </bdi>
      </div>
      <div class="w-full text-right">
         <span>
            <button
               class="px-3 py-1 text-lg text-gray-800 bg-gray-100 rounded cursor-pointer"
               @click="decrement(product_id, index)"
            >
               -
            </button>
            <input v-model="item.count" type="number" min="0" disabled />
            <button
               class="px-3 py-1 text-lg text-gray-800 bg-gray-100 rounded cursor-pointer"
               @click="increment(product_id, index)"
            >
               +
            </button>
         </span>
      </div>
   </div>
</template>

<style scoped>
input[type="number"] {
   appearance: none;
   -moz-appearance: textfield;

   @apply w-14 border-0 text-center;
}
</style>
